
import BaseComponent from '../BaseComponent';

class Checkbox extends BaseComponent{
    
    constructor(aElement){
        
        super(aElement);
        
        this.value = this.element.find('INPUT[type="hidden"]');

        this.attachEvents();
        
    }
    
    attachEvents(){
        
        this.element.on('click', (event)=>{
            console.log('clicked');

            this.element.toggleClass('selected');
            this.value.val(this.element.hasClass('selected')?1:0);
            
            this.onChange(this.value.attr('name'),this.value.val());
            
        });

    }
    
}

export default Checkbox;